<div class="container-fluid">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/coupons'"
    [currentPageValue]="editMode ? 'Edit Coupon' : 'Add Coupon'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addCouponForm" (ngSubmit)="onAddCouponSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-name">
                Coupon Name
              </label>
              <input
                class="form-control"
                id="coupon-name"
                formControlName="couponName"
                placeholder="Coupon Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.couponName.dirty) &&
                  addCouponForm.controls.couponName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.couponName.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-speciality">
                Speciality
              </label>
              <ng-multiselect-dropdown
                [placeholder]="'Select Specialties'"
                [settings]="dropdownSettings"
                [data]="specialities"
                formControlName="couponSpecialties"
                name="multi-select"
              >
              </ng-multiselect-dropdown>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-type"> Type </label>
              <select
                formControlName="couponType"
                class="form-control"
                id="coupon-type"
              >
                <option value="Single Use">Single Use</option>
                <option value="Once Per Customer">Once Per Customer</option>
                <option value="Unlimited">Unlimited</option>
              </select>
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.couponType.dirty) &&
                  addCouponForm.controls.couponType.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.couponType.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-classification">
                Classification
              </label>
              <select
                formControlName="couponClassification"
                class="form-control"
                id="coupon-classification"
              >
                <option value="Normal">Normal</option>
                <option value="Se7etak">Se7etak</option>
              </select>
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.couponClassification.dirty) &&
                  addCouponForm.controls.couponClassification.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.couponClassification.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-startDate">
                Start Date
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="couponStartDate"
                name="bsDatepicker"
                bsDatepicker
                [minDate]="fromMinDate"
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.couponStartDate.dirty) &&
                  addCouponForm.controls.couponStartDate.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.couponStartDate.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-endDate">
                End Date
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="couponEndDate"
                name="bsDatepicker"
                [minDate]="toMinDate"
                bsDatepicker
                [bsConfig]="{
                  isAnimated: true,
                  containerClass: 'theme-blue'
                }"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.couponEndDate.dirty) &&
                  addCouponForm.controls.couponEndDate.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.couponEndDate.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-discount">
                Discount Percentage
              </label>
              <input
                class="form-control"
                id="coupon-discount"
                formControlName="couponDiscountPercentage"
                placeholder="Discount Percentage"
                type="number"
                min="0"
                max="100"
                (change)="onDiscountChange($event)"
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.couponDiscountPercentage.dirty) &&
                  addCouponForm.controls.couponDiscountPercentage.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.couponDiscountPercentage.errors.required">
                  This field is required & the max length is 100!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="coupon-amount">
                Amount
              </label>
              <input
                class="form-control"
                id="coupon-amount"
                formControlName="couponAmount"
                placeholder="Amount"
                type="number"
                min="0"
                (change)="onAmountChange($event)"
                y
              />
              <div
                *ngIf="
                  (isSubmited || addCouponForm.controls.couponAmount.dirty) &&
                  addCouponForm.controls.couponAmount.errors
                "
                class="input-errors"
              >
                <p *ngIf="addCouponForm.controls.couponAmount.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="addCouponForm.invalid"
            >
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/coupons'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
